import React, { useEffect, useRef } from 'react';
export function EditionBar({ animate = false, index = 0, vertical = false, ...props }) {
  const ref = useRef();
  useEffect(() => {
    const node = ref.current,
      media = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!animate || !node?.animate || media.matches || document.hidden) return;
    const motion = node.animate(
      [{ transform: vertical ? 'scaleY(0)' : 'scaleX(0)' }, { transform: 'scale(1)' }],
      {
        duration: 620,
        delay: Math.min(index, 5) * 65,
        easing: 'cubic-bezier(.215,.61,.355,1)',
        fill: 'backwards',
      },
    );
    const finish = () => motion.cancel();
    const visibility = () => {
      if (document.hidden) finish();
    };
    const preference = () => {
      if (media.matches) finish();
    };
    document.addEventListener('visibilitychange', visibility);
    media.addEventListener('change', preference);
    return () => {
      motion.cancel();
      document.removeEventListener('visibilitychange', visibility);
      media.removeEventListener('change', preference);
    };
  }, [animate, index, vertical, props.width, props.height, props.y]);
  return (
    <rect
      {...props}
      ref={ref}
      style={{
        transformBox: 'fill-box',
        transformOrigin: vertical ? 'center bottom' : 'left center',
      }}
    />
  );
}
